<template>
    <span>
        <a-button size="small" type="primary" icon="check"
                  v-on:click.prevent="showModal">{{ $t('Sol. Cesantias') }}</a-button>
        <a-modal title="Solicitar Cesantias"
                 :visible="modalVisible"
                 @ok="confirmar"
                 :confirmLoading="modalLoading"
                 @cancel="cancelar"
                 style="top: 20px;">
              <a-form :form="form" @submit="confirmar">
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Tipo Solicitud"
                              :formItemConfig="fiOptions"
                              :decorator="['layoff_sol_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="requestData.solicitud"
                              :disabled="modalLoading"
                              :selectedObj.sync="tipo_solicitud_seleccionado"></g-dropdown>
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Tipo"
                              :formItemConfig="fiOptions"
                              :decorator="['layoff_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="activarTiposPermisos"
                              :disabled="modalLoading || !tipo_solicitud_seleccionado || tipo_solicitud_seleccionado.value === undefined"
                              :selectedObj.sync="tipo_permiso_seleccionado"></g-dropdown>
                  <g-dropdown endpoint="hierarchy_lookup"
                              label="Sub Tipo"
                              :formItemConfig="fiOptions"
                              :decorator="['layoff_subtype', { rules: [{ required: activarSubTipos, message: 'Valor requerido' }] }]"
                              :params="paramsSubTipo"
                              :disabled="modalLoading || !tipo_permiso_seleccionado || tipo_permiso_seleccionado.value === undefined"
                              :count.sync="cantidadSubTipos"></g-dropdown>
                  <a-form-item label="Monto" v-bind="fiOptions">
                          <a-input-number v-decorator="['layoff_ammount']"
                                          style="width: 100%">
                         </a-input-number>
                  </a-form-item>
                   <g-dropdown endpoint="hierarchy_lookup"
                               :label="$t('¿Va al fondo?')"
                               :formItemConfig="fiOptions"
                               :decorator="['fondocespar', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                               :params="fondosParams"
                   ></g-dropdown>
                   <a-form-item label="Observación" v-bind="fiOptions">
                          <a-textarea placeholder="Observación"
                                      autoSize
                                      v-decorator="['observation']">
                          </a-textarea>
                  </a-form-item>

                  <a-alert v-if="saldoCesantias !== null && !saldoCesantiasLoading && saldoCesantiasError === null"
                                           type="info"
                                           :message="mensajeSaldoCesantias"
                                           showIcon
                                           style="margin-bottom: 16px"/>
                  <a-alert v-else-if="saldoCesantiasLoading"
                           type="info"
                           message="Cargando saldo disponible..."
                           showIcon
                           style="margin-bottom: 16px"/>
                  <a-alert v-else-if="saldoCesantiasError"
                           type="warning"
                           :message="saldoCesantiasError"
                           showIcon
                           style="margin-bottom: 16px"/>

                  <a-row>
                      <a-upload-dragger name="file" :beforeUpload="beforeUpload" :fileList="fileList"
                                        @change="fileChange">
                        <p class="ant-upload-drag-icon">
                            <a-icon type="inbox"/>
                        </p>
                        <p class="ant-upload-text">Clic o arrastrar y soltar en esta área para subir un archivo</p>
                        <p class="ant-upload-hint">
                            Solo es permitido seleccionar un archivo
                        </p>
                    </a-upload-dragger>
                  </a-row>
                <a-alert type="error" :message="mensajeError" v-if="error"/>
              </a-form>
        </a-modal>
    </span>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        modalVisible: false,
        modalLoading: false,
        mensajeError: '',
        saldoCesantias: null,
        saldoCesantiasLoading: false,
        saldoCesantiasError: null,
        tipo_permiso_seleccionado: null,
        tipo_solicitud_seleccionado: null,
        cantidadSubTipos: 0,
        fileList: [],
        isInSubmit: false,
        error: false,
        form: this.$form.createForm(this, {
          name: 'solicitar',
          onFieldsChange: (_, changedFields) => {
            this.formularioActualizado(changedFields)
          }
        }),
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        requestData: {
          solicitud: {h_lookup_type: 'TIPO_SOLICITUD_CESANTIAS', validar_estado_id_h_lookup: true}
        },
        fondosParams: {
          h_lookup_type: 'FONDO_CESANTIAS',
          use_equivalency: true
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.httpDownloadClient = this.httpClient.getNewInstance()
      this.httpDownloadClient.defaults.headers['Content-Type'] = 'multipart/form-data'
    },
    methods: {
      cancelar () {
        if (this.modalLoading) return
        this.modalVisible = false
        this.modalLoading = false
      },
      confirmar (e) {
        e && e.preventDefault()
        this.isInSubmit = true
        this.form.validateFields((err, values) => {
          if (!err) {
            this.modalLoading = true
            const reqData = new FormData()
            const formKeys = ['layoff_sol_type', 'layoff_type', 'layoff_subtype', 'layoff_ammount', 'fondocespar', 'observation']
            for (const key of formKeys) {
              const value = values[key]
              if (value !== null && value !== undefined && value !== '') {
                reqData.append(key, value)
              }
            }
            if (this.fileList.length > 0 && this.fileList[0]) {
              reqData.append('adjunto', this.fileList[0].originFileObj || this.fileList[0])
            }

            this.httpDownloadClient.post('ss/solicitar_cesantias', reqData)
              .then((response) => {
                if (parseInt(response.data.pn_message_type) === 0) {
                  this.error = true
                  this.mensajeError = response.data.pv_message
                } else {
                  this.error = false
                  this.mensajeError = ''
                  this.modalVisible = false
                  Mensajes.success('Correcto', response.data.pv_message)
                  this.form.resetFields()
                  this.tipo_solicitud_seleccionado = null
                  this.tipo_permiso_seleccionado = null
                  this.$emit('success', {})
                }
              })
              .catch((error) => {
                Mensajes.error('Error', 'No fue posible realizar la solicitud.')
                this.error = true
                if (error.response && error.response.data) {
                  const data = error.response.data
                  this.mensajeError = data.mensaje || data.message || 'Error desconocido'
                } else {
                  this.mensajeError = 'Error desconocido'
                }
              })
              .then(() => {
                this.modalLoading = false
                this.isInSubmit = false
              })
          } else {
            this.isInSubmit = false
          }
        })
      },
      formularioActualizado (camposCambiados) {
        if (this.isInSubmit) return

        if (Object.prototype.hasOwnProperty.call(camposCambiados, 'layoff_sol_type')) {
          this.tipo_permiso_seleccionado = null
          this.form.setFieldsValue({
            layoff_type: undefined,
            layoff_subtype: undefined
          })
        }

        if (Object.prototype.hasOwnProperty.call(camposCambiados, 'layoff_type')) {
          this.form.setFieldsValue({
            layoff_subtype: undefined
          })
        }
      },
      showModal () {
        this.tipo_solicitud_seleccionado = null
        this.tipo_permiso_seleccionado = null
        this.modalVisible = true
        this.modalLoading = false
        this.error = false
        this.mensajeError = ''
        this.form.resetFields()
        this.fileList = []
        this.saldoCesantias = null
        this.saldoCesantiasError = null
        this.saldoCesantiasLoading = true
        this.httpClient.getNewInstance().get('param_cespar/monto_cespar')
          .then((response) => {
            this.saldoCesantias = response.data.monto_cespar
            this.saldoCesantiasError = null
          })
          .catch(() => {
            this.saldoCesantias = null
            this.saldoCesantiasError = 'No se pudo cargar el saldo disponible de cesantías.'
          })
          .then(() => {
            this.saldoCesantiasLoading = false
          })
      },
      beforeUpload (file) {
        return false
      },
      fileChange (info) {
        if (info.fileList.length > 0) {
          this.fileList = [info.file]
        } else {
          this.fileList = []
        }
      }
    },
    computed: {
      mensajeSaldoCesantias () {
        if (this.saldoCesantias === null || this.saldoCesantias === undefined || this.saldoCesantias === '') {
          return 'Saldo disponible de cesantías: No determinado'
        }
        const valor = Number(this.saldoCesantias)
        if (isNaN(valor)) {
          return 'Saldo disponible de cesantías: ' + String(this.saldoCesantias)
        }
        return 'Saldo disponible de cesantías: ' + valor.toLocaleString('es-CO', { })
      },
      activarSubTipos () {
        return !JsUtils.isEmpty(this.tipo_permiso_seleccionado) && this.cantidadSubTipos > 0
      },
      activarTiposPermisos () {
        const idFather = (this.tipo_solicitud_seleccionado && this.tipo_solicitud_seleccionado.value !== undefined)
          ? this.tipo_solicitud_seleccionado.value
          : -1
        return {
          h_lookup_type: 'TIPO_CESANTIAS',
          id_h_lookup_father: idFather
        }
      },
      paramsSubTipo () {
        const idFather = (this.tipo_permiso_seleccionado && this.tipo_permiso_seleccionado.value !== undefined)
          ? this.tipo_permiso_seleccionado.value
          : -1
        return {
          h_lookup_type: 'SUBTIPO_SOLICITUD_CESANTIAS',
          id_h_lookup_father: idFather
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/BotonSolicitarCesantias.vue